//事务单

export default [

    {   //事务处理计划
        path: "workorderdetail/list",
        name: "workorderdetail",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/workorder/doubledetailplan/detailindex"),
    },
    {   // 事务处理单
        path: "workordermanage/list",
        name: "workordermanage",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/workorder/doubledetailplan/manageindex"),
    },
    {   //编辑页，查看
        path: "doublieworkor/update/:type",
        name: "doublieworkorUpdate",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/workorder/doubledetailplan/update/index"),
    },
    {   // 事务处理单
        path: "workorderorder/list",
        name: "workorderorder",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/workorder/order/index"),
    },
    {   //事务处理单 编辑页，查看
        path: "workorderorder/update/:type",
        name: "workorderorderUpdate",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/workorder/order/update"),
    },
    
]


